import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import debounce from 'lodash/debounce';
import {
  ChangeEvent,
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { createColumnDependencies } from 'components/ModelList/columns';
import { useURLFilters } from 'hooks/useURLFilters';
import { useURLSearchParams } from 'hooks/useURLSearchParams';

import { FilterIds } from '..';

export const dependencies = createColumnDependencies((ids) => [ids.NAME]);

type InnerProps = { columnId: string };

const Inner: FC<InnerProps> = () => {
  const { updateFilterModelItems } = useURLFilters();
  const [searchParams] = useURLSearchParams();
  const urlName: string = searchParams[FilterIds.NAME] ?? '';

  const [value, setValue] = useState<string>(urlName);

  const updateRef = useRef(updateFilterModelItems);

  useEffect(() => {
    updateRef.current = updateFilterModelItems;
  }, [updateFilterModelItems]);

  const debouncedUpdate = useMemo(
    () =>
      debounce(
        (v: string) => updateRef.current({ [FilterIds.NAME]: v || null }),
        250
      ),
    []
  );

  useEffect(() => () => debouncedUpdate.cancel(), [debouncedUpdate]);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const next = e.currentTarget.value;
      setValue(next);
      debouncedUpdate(next);
    },
    [setValue, debouncedUpdate]
  );

  return (
    <Stack p={1}>
      <TextField
        label="Workflow name contains"
        size="small"
        value={value}
        onChange={handleChange}
      />
    </Stack>
  );
};

const NameContains: FC = () => {
  const [NAME] = dependencies;
  if (!NAME) return null;

  return <Inner columnId={NAME} />;
};

export default NameContains;
